import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const AnecdotesOfParentalCommunityInvolvementInSchool = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Anecdotes of parental / community involvement in school" />
    </Box>
  );
};
